<template>
  <v-card outlined class="mb-3">
    <v-card-subtitle class="d-flex align-center pb-2">
      <v-icon small color="primary" class="mr-2">mdi-silverware-fork-knife</v-icon>
      <span class="font-weight-bold primary--text">{{ $t("attachment_meal") }}</span>
    </v-card-subtitle>
    <v-card-text class="pt-0">
      <autocomplete
        v-model="selectedSideDishes"
        :items="attachmentM"
        dense
        :placeholder="$t('attachment_meal')"
        return-object
        item-text="name"
        item-value="id"
        outlined
        multiple
        chips
        deletable-chips
        small-chips
        hide-details
        @input="onSideDishesChange"
      ></autocomplete>
      <v-divider
        class="my-2"
        v-if="editedItem.prilog && editedItem.prilog.length"
      ></v-divider>
      <div v-if="editedItem.prilog && editedItem.prilog.length">
        <div v-for="dish in editedItem.prilog" :key="dish.id" class="grocery-item">
          <span class="flex-grow-1 text-body-2">{{ dish.name }}</span>
          <remove-button @click="removePrilog(dish)" />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import mealService from "@/services/meal";
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  mixins: [hasSnackbar],
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
    sideDishes: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedSideDishes: [],
    sideDishes2: [],
    loading: false,
  }),
  created() {
    this.loadSideDishes();
    this.initializeSelections();
  },
  methods: {
    loadSideDishes() {
      this.loading = true;
      mealService
        .getSideDishes()
        .then((res) => {
          this.sideDishes2 = res.data;
        })
        .catch((error) => {
          console.error("Error loading side dishes:", error);
          this.showErrorSnackbar(this.$t("error_loading_side_dishes"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initializeSelections() {
      this.selectedSideDishes = [...(this.editedItem.prilog || [])];
    },
    onSideDishesChange(selected) {
      if (!this.editedItem.prilog) {
        this.editedItem.prilog = [];
      }
      // Add newly selected side dishes at the top
      selected.forEach((dish) => {
        const exists = this.editedItem.prilog.find((p) => p.id === dish.id);
        if (!exists) {
          this.editedItem.prilog.unshift({
            ...dish,
            pivot: { quantity: 0 },
          });
        }
      });

      // Remove deselected side dishes
      this.editedItem.prilog = this.editedItem.prilog.filter((p) =>
        selected.some((s) => s.id === p.id)
      );
    },
    removePrilog(item) {
      const index = this.editedItem.prilog.findIndex((i) => i.id === item.id);
      if (index !== -1) {
        this.editedItem.prilog.splice(index, 1);
        this.selectedSideDishes = [...this.editedItem.prilog];
      }
    },
  },
  computed: {
    attachmentM() {
      const attachmentMeals = [...this.sideDishes, ...this.sideDishes2];
      if (!this.editedItem || !this.editedItem.prilog) {
        return attachmentMeals || [];
      }
      return this.editedItem?.prilog
        ? (attachmentMeals || []).filter(
            (item) =>
              !this.editedItem.prilog.some((side) => side.id === item.id) && item?.id
          )
        : attachmentMeals;
    },
  },
  watch: {
    "editedItem.prilog": {
      handler(newVal) {
        if (newVal) {
          this.selectedSideDishes = [...newVal];
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.grocery-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.grocery-item:last-child {
  border-bottom: none;
}

.grocery-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
}
</style>
